import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(@Inject(DOCUMENT) private dom: Document) { }

  updateCanonicalUrl(url: string): void {
    const head = this.dom.getElementsByTagName('head')[0];
    let link: HTMLLinkElement | null = this.dom.querySelector(`link[rel='canonical']`);

    if (!link) {
      link = this.dom.createElement('link') as HTMLLinkElement;
      link.setAttribute('rel', 'canonical');
      head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
  setCanonicalURL(url?: string) {
    const canURL = url == undefined ? this.dom.URL : url;
    const link: HTMLLinkElement = this.dom.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.dom.head.appendChild(link);
    link.setAttribute('href', canURL);
  }
}